<div class="contact-container">
  <!-- Hero Section -->
  <section class="contact-hero" [@fadeInUp]>
    <div class="container">
      <div class="hero-content">
        <h1 class="hero-title">Get In Touch</h1>
        <p class="hero-subtitle">
          Ready to start your next project? We'd love to hear from you.
          Send us a message and we'll respond as soon as possible.
        </p>
      </div>
    </div>
  </section>

  <!-- Main Contact Section -->
  <section class="contact-main">
    <div class="container">
      <div class="contact-layout">
        
        <!-- Contact Form Section -->
        <div class="contact-form-section" [@slideInLeft]>
          <h2 class="form-title">Send us a Message</h2>
          <form class="contact-form" (ngSubmit)="onSubmit()">
            
            <div class="form-row">
              <div class="form-group">
                <label for="name">Full Name *</label>
                <input 
                  type="text" 
                  id="name" 
                  class="form-input" 
                  [(ngModel)]="contactForm.name"
                  name="name"
                  placeholder="Enter your full name"
                  required>
              </div>
              <div class="form-group">
                <label for="email">Email Address *</label>
                <input 
                  type="email" 
                  id="email" 
                  class="form-input" 
                  [(ngModel)]="contactForm.email"
                  name="email"
                  placeholder="Enter your email"
                  required>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="phone">Phone Number *</label>
                <input 
                  type="tel" 
                  id="phone" 
                  class="form-input" 
                  [(ngModel)]="contactForm.phone"
                  name="phone"
                  placeholder="Enter your phone number"
                  required>
              </div>
              <div class="form-group">
                <label for="subject">Subject *</label>
                <input 
                  type="text" 
                  id="subject" 
                  class="form-input" 
                  [(ngModel)]="contactForm.subject"
                  name="subject"
                  placeholder="Enter subject"
                  required>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="message">Message *</label>
                <textarea 
                  id="message" 
                  class="form-textarea" 
                  [(ngModel)]="contactForm.message"
                  name="message"
                  placeholder="Enter your message..."
                  required></textarea>
              </div>
            </div>

            <div class="button-group">
              <button 
                type="submit" 
                class="submit-btn"
                [class.loading]="isSubmitting"
                [disabled]="!isValidForm() || isSubmitting">
                <span *ngIf="!isSubmitting">📧 Send Message</span>
                <span *ngIf="isSubmitting" class="loading-content">
                  <div class="spinner"></div>
                  Sending...
                </span>
              </button>
              
              <button 
                type="button" 
                class="submit-btn whatsapp-btn"
                (click)="requestWhatsAppQuote()">
                💬 WhatsApp Quote
              </button>
            </div>

            <div *ngIf="isSubmitted" class="success-message">
              <span class="success-icon">✅</span>
              Thank you! Your message has been sent successfully.
            </div>
          </form>
        </div>

        <!-- Contact Information Section -->
        <div class="contact-info-section" [@slideInRight]>
          <h2 class="info-title">Contact Information</h2>
          
          <!-- Contact Cards -->
          <div class="contact-cards">
            <div class="contact-card" *ngFor="let info of contactInfo">
              <span class="contact-icon">{{ info.icon }}</span>
              <div class="contact-details">
                <h3 class="contact-title">{{ info.title }}</h3>
                <div class="contact-text">
                  <p *ngFor="let detail of info.details">{{ detail }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Social Section -->
          <div class="social-section">
            <h3 class="social-title">Follow Us</h3>
            <div class="social-links">
              <a 
                *ngFor="let social of socialLinks" 
                [href]="social.url" 
                class="social-btn"
                (click)="openSocialLink(social.url)"
                target="_blank"
                rel="noopener noreferrer">
                <i [class]="social.icon"></i>
                <span class="sr-only">{{ social.name }}</span>
              </a>
            </div>
          </div>

          <!-- FAQ Section -->
          <div class="faq-section">
            <h3 class="faq-title">Frequently Asked Questions</h3>
            <div class="faq-item" *ngFor="let faq of faqs">
              <h4 class="faq-question">{{ faq.question }}</h4>
              <p class="faq-answer">{{ faq.answer }}</p>
            </div>
          </div>

          <!-- Map Section -->
          <div class="map-section">
            <h3 class="map-title">Find Us Here</h3>
            <div class="map-container">
              <iframe 
                class="map-iframe"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3767.8!2d72.99!3d19.16!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDA5JzM2LjAiTiA3MsKwNTknMjQuMCJF!5e0!3m2!1sen!2sin!4v1234567890"
                allowfullscreen
                loading="lazy">
              </iframe>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  </section>
</div>
